import React from 'react';
import Layout from '@/components/Layout';
import PollenDotsNav from '@/components/PollenDotsNav';
import { CelebrationsFull } from '@/components/Celebrations';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/App';

const PollenDotsCelebrations = () => {
  const { user } = useAuth();
  if (!['Pollen Dots User', 'Super Admin', 'Admin', 'Operator', 'Intern'].includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return (
    <Layout>
      <PollenDotsNav />
      <CelebrationsFull />
    </Layout>
  );
};

export default PollenDotsCelebrations;
